const en_payment_commission = {
    label: {
        commission: "commission",
        commission_total: "total commission",
        commission_total_selected: "total selected commission",
        pay: "commission payment",
        bank: "payment account"
    },

    message: {
        process: "commissions to be processed ( {{count}} ): "
    },

    error: {
        account_bank: "payment account is required.",
        create: "failed to process payment.",
    },

    success: {
        create: "payment processed successfully.",
    }
}

export default en_payment_commission;